const color = {
  mainWhite: "#ffffff",
  mainBlack: "#191F28",
  mainGray: "#969a9f",
  SubGray: "#474747",
  mainRed: "#f51919",
  MessageList: "#4a4a4a",
  MessageListBg: "#fbfbfb",
  track: "#e1e1e1",
  thumbBg: "#6f6f6f",
  thumbBorder: "#353535",
  hover: "#555",
  info: "#ffd677",
  infoBg: "#fff4c0",
};
const theme = {
  color,
};
export default theme;
